import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import {
  requestLocations,
  requestActivityStatuses,
} from '../../../store/location-manager/LocationManagerActions';
import { isStaff, isExecutive } from '../../../store/current-user/CurrentUserSelectors';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import Moment from '../../../components/utils/Moment';
import { hostTitle } from '../../../config/ui';

class LocationManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filtered: [],
      selectedOption: 2,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    const { getActivityStatuses } = this.props;
    getActivityStatuses({
      tenantId: this.props.tenantId,
    });
  }

  handleChange(event) {
    this.setState({ selectedOption: event.target.value }, () =>
      this.table.fireFetchData(),
    );
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getLocations({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
        showValue: this.state.selectedOption,
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  editLocation = (clinicLocationID) => {
    hashHistory.push(`/location-manager/location/${clinicLocationID}`);
  };

  addLocation = (clinicLocationID) => {
    hashHistory.push(`/location-manager/location/${clinicLocationID}`);
  };

  detailLocation = (siteCode) => {
    hashHistory.push(`/location-manager/detail/${siteCode}`);
  };

  render() {
    const { data, activityStatuses, isStaff, isExecutive } = this.props;
    return (
      <div id="content">
        <Helmet title={`Location Manager – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Administration', 'Location Manager']}
              icon="fa fa-fw fa-database"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Location Manager</h2>
                    <div className="widget-toolbar">
                    <button disabled={isStaff || isExecutive}
                        className="btn btn-primary btn-xs"
                        onClick={() => this.addLocation(0)}
                      >
                        Add Location
                      </button>
                    </div>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <div
                      style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}
                    >
                      <div className="form-inline">
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="status"
                            value={this.state.selectedOption}
                            onChange={this.handleChange}
                          >
                            {activityStatuses &&
                              activityStatuses.map((el) => (
                                <option key={el.id} value={el.id}>
                                  {el.name}
                                </option>
                              ))}
                            <option value="6">Show All</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      defaultSorted={[
                        {
                          id: 'siteName',
                          desc: false,
                        },
                      ]}
                      columns={[
                        {
                          Header: '',
                          id: 'actions',
                          width: 50,
                          sortable: false,
                          Cell: (row) => (
                            <span>
                              <button disabled={isStaff || isExecutive}
                                className="btn btn-default btn-xs"
                                onClick={() =>
                                  this.editLocation(
                                    row.original.clinicLocationID,
                                  )
                                }
                              >
                                <i className="fa fa-pencil" />
                              </button>
                            </span>
                          ),
                        },
                        {
                          Header: 'Location Name',
                          id: 'siteName',
                          accessor: 'siteName',
                          Cell: (row) => (
                            <a
                              onClick={() =>
                                this.detailLocation(
                                  row.original.clinicLocationID,
                                )
                              }
                            >
                              {row.original.siteName}
                            </a>
                          ),
                        },
                        {
                          Header: 'Location Code',
                          id: 'siteCode',
                          accessor: 'siteCode',
                        },
                        {
                          Header: 'Location ID',
                          id: 'clinicLocationID',
                          accessor: 'clinicLocationID',
                        },
                        {
                          Header: 'Address1',
                          id: 'address1',
                          accessor: 'address1',
                        },
                        {
                          Header: 'Address2',
                          id: 'address2',
                          accessor: 'address2',
                        },
                        {
                          Header: 'City',
                          id: 'city',
                          accessor: 'city',
                        },
                        {
                          Header: 'State',
                          id: 'state',
                          accessor: 'state',
                        },
                        {
                          Header: 'Zip',
                          id: 'zip',
                          accessor: 'zip',
                        },
                        {
                          Header: 'Start Date',
                          id: 'startDate',
                          accessor: 'startDate',
                          Cell: (row) => (
                            <Moment
                              date={row.original.startDate}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Weekly Hours',
                          id: 'weeklyHours',
                          accessor: 'weeklyHours',
                        },
                        {
                          Header: 'Phone Number',
                          id: 'phoneNumber',
                          accessor: 'phoneNumber',
                        },
                        {
                          Header: 'Pharmacy Site ID',
                          id: 'siteNumber',
                          accessor: 'siteNumber',
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.locationmanager,
    tenantId: state.currentUser.queryParams.tenantId,
    isStaff: isStaff(state),
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getLocations: (params) => dispatch(requestLocations(params)),
    getActivityStatuses: (params) => dispatch(requestActivityStatuses(params)),
  }),
)(LocationManager);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/LocationManager.js